import { RenderOptionProps } from '@workwhile/ui'
import { Box, Text } from 'ui'
import { AudienceType } from '../../schemas'
import { Roster } from './Roster'
import { RSW } from './RSW'
import { RadioOption } from '../../RadioOption'
import { useShiftEditor } from 'pages/ShiftEditorPage/useShiftEditor'

export function AudienceTypeOption(props: RenderOptionProps) {
  const { indicator, isSelected, option } = props
  const { isOnDemandDeliveryBlock } = useShiftEditor()

  const defaultAudience = isOnDemandDeliveryBlock
    ? 'Intelligently target preferred delivery drivers. Favorites are notified first, followed by experienced delivery drivers before we offer to the broad marketplace.'
    : 'Intelligently target preferred workers. Favorites are notified first, followed by experienced workers before we offer to the broad marketplace.'
  return (
    <RadioOption $isSelected={isSelected}>
      {indicator}
      <Box flex={1} ml={3} pr={4}>
        <Text fontWeight={2} className={'option-title'}>
          {option.label}
        </Text>
        {option.value === AudienceType.Default ? (
          <Text mt={2}>{defaultAudience}</Text>
        ) : null}
        {option.value === AudienceType.Roster && isSelected ? <Roster /> : null}
        {option.value === AudienceType.SpecificWorkers && isSelected ? (
          <RSW />
        ) : null}
      </Box>
    </RadioOption>
  )
}
